import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataType: {
      default: 0
    }
  },
  name: 'BlindDateEdit',
  data: function data() {
    return {
      title: '',
      form: {
        blindDataId: null,
        gear: '',
        purchaseNum: null,
        acount: null,
        remarksOne: '',
        remarksTwo: '',
        type: this.dataType,
        createTime: null,
        isDel: null
      },
      rules: {
        blindDataId: [{
          required: true,
          message: '请输入主键',
          trigger: 'blur'
        }],
        gear: [{
          required: true,
          message: '请输入档位',
          trigger: 'blur'
        }],
        purchaseNum: [{
          required: true,
          message: '请输入购买次数',
          trigger: 'blur'
        }],
        acount: [{
          required: true,
          message: '请输入购买金额',
          trigger: 'blur'
        }],
        remarksOne: [{
          required: true,
          message: '请输入备注1',
          trigger: 'blur'
        }],
        remarksTwo: [{
          required: true,
          message: '请输入备注2',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请输入活动分类（0 视频云相亲 1 线下相亲会）',
          trigger: 'blur'
        }],
        createTime: [{
          required: true,
          message: '请输入创建时间',
          trigger: 'blur'
        }],
        isDel: [{
          required: true,
          message: '请输入删除标记',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.enumList = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.blindDataId = null;
      this.form.gear = null;
      this.form.purchaseNum = null;
      this.form.acount = null;
      this.form.remarksOne = null;
      this.form.remarksTwo = null;
      this.form.type = this.dataType;
      this.form.createTime = null;
      this.form.isDel = null;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.blindDataId = data.blindDataId + '';
      this.form.gear = data.gear;
      this.form.purchaseNum = data.purchaseNum + '';
      this.form.acount = data.acount + '';
      this.form.remarksOne = data.remarksOne;
      this.form.remarksTwo = data.remarksTwo;
      this.form.type = data.type + '';
      this.form.createTime = data.createTime + '';
      this.form.isDel = data.isDel + '';
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.UPDATE_BLINDDATE(_this2.form);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
              _this2.handleClose();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    saveApi: function saveApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.SAVE_BLINDDATE(_this3.form);
            case 1:
              _this3.$emit('initTableData');
              _this3.$message.success('操作成功');
              _this3.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    save: function save() {
      var _this4 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this4.form.blindDataId != null) {
            _this4.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this4.updateApi();
            }).catch(function () {
              _this4.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this4.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};